import { render, staticRenderFns } from "./JobsInfo.vue?vue&type=template&id=9d7b674a&"
import script from "./JobsInfo.vue?vue&type=script&lang=js&"
export * from "./JobsInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports